import { BLOCK_CLASSES } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
export const spacerSpec = {
  content: '',
  group: 'block',
  attrs: {
    type: {
      default: 'spacer'
    },
    height: {
      default: 20
    }
  },
  toDOM(_node) {
    return ['div', {
      class: `${BLOCK_CLASSES.blockContainer} ${BLOCK_CLASSES.spacer} intercom-spacer-container`
    }];
  }
};